define('views/modules/questionnaire/list/questionnaire-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/media-info-box',
    // templates
    'text!templates/modules/questionnaire/list/questionnaire-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // services
    i18n,
    // views
    VMediaInfoBox,
    // templates
    TQuestionnaireListItem
) {

    var VQuestionnaireListItem = Backbone.View.extend({
        template: TQuestionnaireListItem,

        regions: {
            infobox: ".item-section",
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'title',
                    model: this.model,
                    context: this,
                    onClick: this.onQuestionnaireClick,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onActionClick,
                    }
                }),
            };

            this.listenTo(this.model, {
                'remove': this.remove,
            });
        },
        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.infobox, this.regions.infobox);
            // needs menu regions from infobox el

            return this;
        },

        deleteQuestionnaire: function(result) {
            if (!result) return;
            this.model.destroy({
                context: this,
                wait: true,
                error: function(model, response) {
                    // FIXME add error notification when questionnaire deletion failed
                    if (response.responseJSON) {
                        U.warn(response.responseJSON.message);
                    }
                }
            });

        },

        ////////////
        // events //
        ////////////

        onMenuInit: function() {
            var menuActions = new Backbone.Collection([
                { caption: 'Edit', icon: "sl-icon-note", callback: this.onEditAction },
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction },
                { caption: 'messages:Get the form link', icon: 'fa fa-link', callback: this.onGetLinkAction, context: this },
                { caption: 'questionnaire:Publish', icon: "sl-icon-share-alt", callback: this.onPostAction },
            ]);

            return menuActions;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onEditAction: function(e) {
            this.model.trigger("questionnaire:edit", this.model);
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: i18n.t("Delete questionnaire"),
                message: i18n.t("messages:message-delete-questionnaire"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteQuestionnaire,
                context: this,
            });
        },

        onGetLinkAction: function() {
            this.model.trigger("questionnaire:link", this.model);
        },

        onPostAction: function() {
            this.model.trigger("questionnaire:post", this.model);
        },

        onQuestionnaireClick: function(e) {
            this.model.trigger("questionnaire:click", this.model);
        },

    });

    return VQuestionnaireListItem;

});

